import Animation from "./Animation";
import { gsap, Sine } from "gsap";

/**
 * A custom element class for accessing window events and associated callbacks for animations
 * @extends Animation
 * @property {Function} animate the animation this class will run
 * @property {Function} setDefault set defaults for animation or element
 * @property {Function} onViewportExit a callback function for intersection observer exit
 */
class Fade extends Animation {

	/**
	 * Runs the animation
	 * @param {function} done animation complete callback, passed into run()
	 */
	animate({ done }) {
		console.log("Animating.")
		gsap.fromTo(this.element, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.5,
			ease: "Power2.inOut",
			onComplete: done
		});
	}

	/**
	 * Will fire when element binds to the DOM, use this to
	 * set up default states if needed
	 */
	setDefault() {
		/** --- Start hidden --- */
		gsap.set(this.element, {
			opacity: 0
		});
	}

	/**
	 * Intersection Observer callback, only needs to fire this.run()
	 * this.run() can contain a callback function for done()
	 */
	onViewportEnter() {

		this.run(() => {
		});
	}
}

export default Fade;
